<template>
  <div class="question-tab">
    <p>{{ heading }}</p>

    <div v-if="type == 'location'" class="button-div">
      <button
        v-for="item in data"
        :key="item.id"
        @click="handlelocations(item)"
        :class="stateId.includes(item.id) ? 'green-btn' : 'default-btn'"
      >
        {{ item.eng_name }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "locationTab",
  data() {
    return {
      stateId: [],
    };
  },
  props: {
    heading: String,
    type: String,
    data: Array,
  },
  mounted() {
    // console.log(this.data);
  },
  watch: {},
  created() {
    this.stateId = this.$store.getters[
      "crmFilters/GET_STATES_DATA"
    ]
      ? this.$store.getters["crmFilters/GET_STATES_DATA"]
      : [];
  },
  methods: {
    handlelocations(item) {
      console.log("item", item);
      if (!this.stateId.includes(item.id)) {
        this.stateId.push(item.id);
      } else {
        const index = this.stateId.indexOf(item.id);
        if (index > -1) {
          // only splice this.stateId when item is found

          this.stateId.splice(index, 1); // 2nd parameter means remove one item only
        }
      }

      console.log("states", this.stateId);
      this.$store.dispatch("crmFilters/setStatesData", this.stateId);
      // getdata.push(getdata)
    },
  },
};
</script>
<style lang="scss" scoped>
.question-tab {
  display: flex;
  flex-direction: column;
  margin-left: 28px;
  // margin-top:28px;
  //row-gap: 24px;
  overflow-y: scroll;
  p {
    margin: 0;
  }
}
.button-div {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  height: 600px;
}
.default-btn {
  height: 35px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #efefef;
  color: #4b4b4b;
  padding: 8px 12px;
  border-radius: 4px;
}
.green-btn {
  height: 35px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #efefef;
  color: #189d3b;
  background: #f3faf5;
  padding: 8px 12px;
  border-radius: 4px;
}
</style>
